import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useLetterTemplates = (patientId, consultationId, { enabled = true } = {}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["letterTemplates", tenantVal, patientId, consultationId],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const params = new URLSearchParams();
      if (patientId) params.append("patientId", patientId);
      if (consultationId) params.append("consultationId", consultationId);
      const queryString = params.toString();
      const url = queryString
        ? `${tenantVal}/lettertemplate?${queryString}`
        : `${tenantVal}/lettertemplate`;
      const response = await axiosInstance.get(url);

      return response.data;
    },
    enabled: !!tenantVal && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};